<template>
  <div class="nslide">
    <a href="javascript:void(0);" v-for='(i,index) in DisForm.infoList' :key='index' :class='{"curs":DisForm.curIndex==index}'>
      <span @click='see(index)'>{{htit}}</span>
      <a-popconfirm title="确认删除此进度吗?" ok-text="确定" cancel-text="取消" @confirm="del(index)" v-if='DisForm.infoList && $common.AccAUTH($store.state.cause.accuser.id,$store.getters.stepPower.del)'>
        <a-icon type="close-circle" class="close" v-if='DisForm.copyIndex.indexOf(index)>=0' />
        <a-icon type="close-circle" class="close" v-if='DisForm.copyIndex.indexOf(index)<0' />
      </a-popconfirm>
    </a>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import { delJd } from "@/server/speed"
import liteKey from "@/page/ly/liteKey.json"
export default {
  props: {
    openEdit: {
      type: Boolean
    }
  },
  data() {
    return {

    }
  },
  computed: {
    ...mapGetters([
      'DisForm'
    ]),
    htit() {
      if (this.DisForm.infoList) {
        const item = this.DisForm.infoList.filter(ele => {
          return ele.step
        })
        if (item.length > 0) {
          return liteKey[item[0].step]
        } else {
          return ""
        }
      } else {
        return ""
      }
    }
  },
  methods: {
    ...mapActions({
      scroll: 'DisForm/scroll',
    }),
    next() {
      this.scroll({ type: "next" }).then(index => {
        this.see(index)
      })
    },
    prev() {
      this.scroll({ type: "prev" }).then(index => {
        this.see(index)
      })
    },
    del(index) {
      if (this.DisForm.copyIndex.indexOf(index) >= 0) {
        this.$emit("delCopy", index)
      } else {
        delJd({ step_id: this.DisForm.infoList[this.DisForm.curIndex].id }).then(e => {
          /// this.$emit("delCopy", index)
          this.$message.success("已提交审核")
          setTimeout(e => {
            window.history.go(0)
          }, 500)
        })
      }
    },
    see(index) {
      if (index == this.DisForm.curIndex) return false;
      this.$emit("getIndex", index)
    }
  }
}
</script>
<style lang="less" scoped>
.nslide {
  display: flex;
  flex-wrap: wrap;
  border-bottom: 1px solid #e8e8e8;
  margin-top: -10px;
  margin-bottom: 20px;
  padding-bottom: 4px;
  a {
    min-width: 136px;
    line-height: 36px;
    color: #1d8bfe;
    border-radius: 4px;
    text-align: center;
    background: rgba(29, 139, 254, 0.1);
    margin-right: 15px;
    font-size: 13px;
    display: block;
    margin-bottom: 10px;
    box-sizing: border-box;
    padding: 0 10px;
    span {
      margin-right: 6px;
    }
  }
  .curs {
    color: #fff;
    background: rgba(29, 139, 254, 1);
  }
}
</style>